import React from "react";
import "./portfolio.css";
import p1 from "../../assets/p1.jpg";
import p2 from "../../assets/p2.jpg";
import p3 from "../../assets/p3.jpg";
import p4 from "../../assets/p4.jpg";
import p5 from "../../assets/p5.jpg";
import p6 from "../../assets/p6.jpg";
import p7 from "../../assets/p7.jpg";

const Portfolio = () => {
  return (
    <div
      id="portfolio"
      className="portfolio__container"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridTemplateRows: "repeat(4, 1fr)",
      }}
    >
      <div className="portfolio__categories">
        <div
          className="porfolio__border headertext"
          style={{ gridColumn: "1 / 2", gridRow: "1 / 2" }}
        >
          <h1 className="portfolio__header">
            Latest <br /> creations
          </h1>
          <h3 className="portfolio__subheader"> We make beautiful things</h3>
          <p className="portfolio__paragraph">
            {" "}
            Focus infographic venture business model canvas gamification
            ecosystem. Business plan gamification user experience low hanging
            fruit twitter. Metrics research & development market paradigm shift
            growth hacking.
          </p>
        </div>
        <div
          className="porfolio__border "
          style={{ gridColumn: "2 / 3", gridRow: "1 / 2" }}
        >
          <div className="portfolio__content">
            <p className="portfolio__content-text">PORTFOLIO TITLE <br />Branding, WebDesign</p>
          </div>
          <img className="portfolio__img" src={p1} alt="" />
        </div>
      </div>

      <div className="portfolio__categories">
        <div
          className="porfolio__border "
          style={{ gridColumn: "2 / 3", gridRow: "1 / 2" }}
        >
          <div className="portfolio__content">
            <p className="portfolio__content-text">PORTFOLIO TITLE <br />Branding, WebDesign</p>
          </div>
          <img className="portfolio__img" src={p3} alt="" />
        </div>
        <div
          className="porfolio__border "
          style={{ gridColumn: "2 / 3", gridRow: "1 / 2" }}
        >
          <div className="portfolio__content">
            <p className="portfolio__content-text">PORTFOLIO TITLE <br />Branding, WebDesign</p>
          </div>
          <img className="portfolio__img" src={p4} alt="" />
        </div>
      </div>

      <div className="portfolio__categories">
        <div
          className="porfolio__border "
          style={{ gridColumn: "2 / 3", gridRow: "1 / 2" }}
        >
          <div className="portfolio__content">
            <p className="portfolio__content-text">PORTFOLIO TITLE <br />Branding, WebDesign</p>
          </div>
          <img className="portfolio__img" src={p2} alt="" />
        </div>
        <div
          className="porfolio__border "
          style={{ gridColumn: "2 / 3", gridRow: "1 / 2" }}
        >
          <div className="portfolio__content">
            <p className="portfolio__content-text">PORTFOLIO TITLE <br />Branding, WebDesign</p>
          </div>
          <img className="portfolio__img" src={p5} alt="" />
        </div>
      </div>

      <div className="portfolio__categories">
        <div
          className="porfolio__border "
          style={{ gridColumn: "2 / 3", gridRow: "1 / 2" }}
        >
          <div className="portfolio__content">
            <p className="portfolio__content-text">PORTFOLIO TITLE <br />Branding, WebDesign</p>
          </div>
          <img className="portfolio__img" src={p6} alt="" />
        </div>
        <div
          className="porfolio__border "
          style={{ gridColumn: "2 / 3", gridRow: "1 / 2" }}
        >
          <div className="portfolio__content">
            <p className="portfolio__content-text">PORTFOLIO TITLE <br />Branding, WebDesign</p>
          </div>
          <img className="portfolio__img" src={p7} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
